import { Card, CardContent } from "@/components/ui/card";
import { dec } from "./format";

const COLS = [["par_ug", "Par.Ug."], ["lunghezza", "Lunghezza"], ["larghezza", "Larghezza"], ["h_peso", "Altezza/Peso"]];

const Th = ({ children, right }) => (
  <th className={`py-2 px-2 text-[10px] uppercase tracking-widest font-semibold text-slate-500 ${right ? "text-right" : "text-left"}`}>{children}</th>
);

export const MisurazioniExcel = ({ misure, totaleMisure, voce }) => {
  const quadra = totaleMisure !== null && Math.abs(Number(totaleMisure) - Number(voce.quantita)) < 0.0005;
  return (
    <Card data-testid="excel-misurazioni"><CardContent className="p-4 sm:p-6">
      <div className="flex flex-wrap items-baseline justify-between gap-2 mb-3">
        <div className="text-xs uppercase tracking-widest text-amber-600 font-semibold">Misurazioni originali dell'Excel</div>
        <div className="text-xs text-slate-500" data-testid="excel-misurazioni-count">{misure.length} {misure.length === 1 ? "riga" : "righe"} · ordine del file</div>
      </div>
      {misure.length === 0 ? <p className="text-sm text-slate-500">Nessuna misurazione nel file per questa voce.</p> : (
        <div className="overflow-x-auto -mx-4 sm:mx-0 max-h-[480px] overflow-y-auto">
          <table className="w-full text-sm min-w-[640px]">
            <thead className="sticky top-0 bg-white dark:bg-slate-950 border-b"><tr>
              <Th>#</Th><Th>Descrizione</Th>{COLS.map(([k, l]) => <Th key={k} right>{l}</Th>)}<Th right>Q.tà parziale</Th>
            </tr></thead>
            <tbody>{misure.map((m) => (
              <tr key={m.id} className="border-b border-slate-100 dark:border-slate-800" data-testid={`excel-misura-${m.ordine}`}>
                <td className="py-1.5 px-2 text-xs text-slate-400 font-mono">{m.ordine}</td>
                <td className="py-1.5 px-2">{m.descrizione || <span className="text-slate-400">—</span>}</td>
                {COLS.map(([k]) => <td key={k} className="py-1.5 px-2 text-right font-mono text-xs">{dec(m[k], 0, 4)}</td>)}
                <td className="py-1.5 px-2 text-right font-mono">{dec(m.quantita, 2, 4)}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
      <div className="mt-4 flex flex-wrap gap-x-6 gap-y-1 text-sm border-t pt-3">
        <span>Somma misurazioni: <b className="font-mono" data-testid="excel-misure-somma">{dec(totaleMisure, 2, 4)}</b></span>
        <span>Quantità totale voce: <b className="font-mono text-amber-700" data-testid="excel-quantita-voce">{dec(voce.quantita, 2, 4)} {voce.um || ""}</b></span>
        {misure.length > 0 && <span className={quadra ? "text-emerald-700" : "text-rose-700"} data-testid="excel-misure-quadratura">{quadra ? "Quadratura OK" : "Somma diversa dalla quantità"}</span>}
      </div>
    </CardContent></Card>
  );
};
